import AlertInterface from '../../alert-interface.js';
import Toast from 'bootstrap/js/dist/toast';

const container = document.getElementById('toast_stack_container');
const targetElement = document.querySelector('#toast_stack_container [data-toast="stack"]'); // Use CSS class or HTML attr to avoid duplicating ids
targetElement.parentNode.removeChild(targetElement);
/**
 * displays basic message with elatus logo
 * @link https://getbootstrap.com/docs/5.1/components/toasts
 */
class BasicToastAlert extends AlertInterface {
    constructor(data) {
        super();

        this.data = data;
    }

    show() {
        const newToast = targetElement.cloneNode(true);
        newToast.querySelector(".toast-body").textContent = this.data.message;
        container.append(newToast);

        const toast = Toast.getOrCreateInstance(newToast);
        toast.show();
    }
}

export default BasicToastAlert;
